import { defineNuxtPlugin } from '#app';
import { reactive } from 'vue';

const events = reactive(new Map());

export const EventBus = {
    fire: (event, data) => {
        if (!events.has(event)) {
            events.set(event, []);
        }
        events.get(event).forEach(callback => {
            return callback(data);
        });
    },
    on(event, callback) {
        if (!events.has(event)) {
            events.set(event, []);
        }
        events.get(event).push(callback);
    },
    off(event, callback) {
        if (events.has(event)) {
            const callbacks = events.get(event);
            const index = callbacks.indexOf(callback);
            if (index > -1) {
                callbacks.splice(index, 1);
            }
        }
    }
};

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('events', EventBus);
});
